import React from 'react';
import {
  Datagrid,
  SimpleForm,
  TextInput,
  Resource,
  TextField,
  BooleanField,
  Filter as RAFilter,
  SelectInput,
  EditButton,
  NullableBooleanInput
} from 'react-admin';
import { AppCreate, AppEdit, AppList } from 'components/CRUD';
import Icon from '@material-ui/icons/Tune';
import { usePermissions, READ_MANAGEMENT_SERVICES, EDIT_MANAGEMENT_SERVICES } from "../utils/permissions";
import JsonInput from 'components/Inputs/JSONInput';
import { Box } from '@material-ui/core';

const Filter = props => (
  <RAFilter {...props}>
    <TextInput source="name" alwaysOn />
    <NullableBooleanInput source='enabled' alwaysOn />
    <NullableBooleanInput source='isDefault' alwaysOn />
    <SelectInput
      source='type'
      alwaysOn
      choices={[
        {id: 'tile', name: 'Tile'},
        {id: 'flyout', name: 'Flyout'},
        {id: 'module', name: 'Module'},
        {id: 'database', name: 'Database'},
        {id: 'feature', name: 'Feature'},
        {id: 'data_processor', name: 'Data Processor'},
      ]}
    />
  </RAFilter>
);

export const List = props => {
  const { hasPermission: hasReadPermission } = usePermissions(READ_MANAGEMENT_SERVICES);
  const { hasPermission: hasEditPermission } = usePermissions(EDIT_MANAGEMENT_SERVICES);

  // show the edit button if we allow any show or edit permissions
  const editButtonDisabled = !( hasReadPermission || hasEditPermission );

  return (
    
  <AppList permission='management-services' {...props} filters={<Filter />}>
    <Datagrid>
      <TextField source='name' />
      <TextField source='type' />
      <BooleanField source='enabled' />
      <TextField source='isDefault' />
      <EditButton disabled={editButtonDisabled} />
    </Datagrid>
  </AppList>
  )
}

const Primary = ({readOnly}) => (
  <Box width='100% !important' display='flex'>
    <Box width={0.5} display='flex' flexDirection={'column'} p={2}>
        <TextInput source='name' disabled={readOnly} />
        <SelectInput
          label='Enabled'
          source='enabled'
          choices={[
            { id: true, name: 'Yes' },
            { id: false, name: 'No '}
          ]}
          disabled={readOnly}
        />
        <SelectInput
          label='Is Default Service'
          source='isDefault'
          choices={[
            { id: true, name: 'Yes' },
            { id: false, name: 'No '}
          ]}
          disabled={readOnly}
        />
        <TextInput source='machineName' disabled={readOnly} />
        <SelectInput
          source='type'
          choices={[
            {id: 'tile', name: 'Tile'},
            {id: 'flyout', name: 'Flyout'},
            {id: 'module', name: 'Module'},
            {id: 'database', name: 'Database'},
            {id: 'feature', name: 'Feature'},
            {id: 'data_processor', name: 'Data Processor'},
          ]}
          disabled={readOnly}
        />
    </Box>
    <Box width={0.5} display='flex' flexDirection={'column'} p={2}>
      <JsonInput
        source="options"
        disabled={readOnly}
      />
    </Box>
  </Box>
)

export const Edit = props => {
  const { hasPermission: hasEditPermission } = usePermissions(EDIT_MANAGEMENT_SERVICES);

  //Intentional until custom wysiwyg tools
  const readOnly = true || !(hasEditPermission);

  return (
    <AppEdit permission='management-services' {...props} undoable={false}>      
      <SimpleForm warnWhenUnsavedChanges>
        <Primary readOnly={readOnly} edit />
      </SimpleForm>
    </AppEdit>
  );
};

export const Create = props => {
  return (
    <AppCreate  permission='management-services' {...props} undoable={false}>      
      <SimpleForm warnWhenUnsavedChanges>
        <Primary readOnly={false} />
      </SimpleForm>
    </AppCreate>
  );
};


const Admin = () => <Resource name="ManagementService" options={{label: 'Services'}} list={List} edit={Edit} icon={Icon} />;

export default Admin;